import { render } from "./MonitorCard.vue?vue&type=template&id=088d551a&scoped=true&ts=true"
import script from "./MonitorCard.vue?vue&type=script&lang=ts"
export * from "./MonitorCard.vue?vue&type=script&lang=ts"

import "./MonitorCard.vue?vue&type=style&index=0&id=088d551a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088d551a"]])

export default __exports__